import cookie from 'js-cookie';

export default function createCookieManager() {
  let globalOptions = {};

  function filterOptions(options) {
    const mergedOptions = {
      ...globalOptions,
      ...options
    };

    const maxAgeMS = mergedOptions.maxAge * 1000;

    delete mergedOptions.maxAge;

    return {
      ...mergedOptions,
      expires: new Date(Date.now() + maxAgeMS)
    };
  }

  return {
    get(key) {
      return cookie.get(key);
    },

    setGlobalOptions(options) {
      globalOptions = options;
    },

    remove(key, options) {
      return cookie.remove(key, filterOptions(options));
    },

    set(key, value, options) {
      return cookie.set(key, value, filterOptions(options));
    }
  };
}
